<template>
    <div class="form-container">
        <div style="display: flex; justify-content: center; margin: 0 0 40px">
            <div
                style="
                    background: #50e3c235;
                    padding: 20px 100px;
                    border-radius: 10px;
                    text-align: center;
                "
            >
                <h3 style="font-size: 25px">
                    <span>
                        {{
                            $t(
                                "There are special prices for stores and companies"
                            )
                        }}
                    </span>

                    <a href="https://wa.link/mg3puu" target="_blank">{{
                        $t("Press Here")
                    }}</a>
                </h3>
            </div>
        </div>
        <div class="columns">
            <div class="column is-half">
                <div class="columns">
                    <div class="column is-three-quarters">
                        <span id="form-title-top">
                            {{ $t("Now, choose the service you prefer") }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div dir="ltr">
            <span v-if="rates.length > 3" class="more-rates">{{
                $t("More choices")
            }}</span>
            <carousel
                :navigateTo="rates.length - 1"
                :autoplay="false"
                :navigationEnabled="true"
                :paginationEnabled="true"
                :perPageCustom="perPage"
            >
                <template v-for="(slide, i) in rates">
                    <slide v-if="slide.id == lowestService" :key="'f-' + i">
                        <div
                            :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                            class="slider"
                            @click="selectService(slide)"
                        >
                            <div class="slide_parent">
                                <div
                                    :class="[
                                        'slide_child',
                                        { active: choosedItem.id == slide.id },
                                    ]"
                                >
                                    <div>
                                        <div>
                                            <p
                                                :class="[
                                                    'best_offer',
                                                    {
                                                        active:
                                                            choosedItem.id ==
                                                            slide.id,
                                                    },
                                                ]"
                                                v-if="lowestService == slide.id"
                                            >
                                                {{ $t("Best offer") }}
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <p
                                            class="price"
                                            v-if="!useSAR.includes(slide.id)"
                                        >
                                            <span
                                                class="f-45"
                                                v-if="
                                                    shipment.sendFrom.country ==
                                                    'United States'
                                                "
                                                >$</span
                                            >
                                            <span
                                                v-if="!showOnlyPrice"
                                                class="num"
                                            >
                                                <number
                                                    ref="number1"
                                                    :from="
                                                        handleMoney(
                                                            slide.price +
                                                                slide.savings
                                                        )
                                                    "
                                                    :to="
                                                        handleMoney(slide.price)
                                                    "
                                                    :format="theFormat"
                                                    :duration="2"
                                                    :delay="3"
                                                    easing="Power1.easeOut"
                                                />
                                            </span>
                                            <span
                                                v-if="showOnlyPrice"
                                                class="num"
                                                >{{
                                                    (slide.price / 3.75)
                                                        | currency("")
                                                }}</span
                                            >
                                            <span
                                                class="f-10"
                                                v-if="
                                                    shipment.sendFrom.country !=
                                                    'United States'
                                                "
                                                >{{ $t("SAR") }}</span
                                            >
                                        </p>
                                        <p
                                            class="price"
                                            v-if="
                                                shipment.sendFrom.country ==
                                                    'United States' &&
                                                useSAR.includes(slide.id)
                                            "
                                        >
                                            <span class="f-45">{{
                                                slide.price | currency("")
                                            }}</span>
                                            <span>{{ $t("SAR") }}</span>
                                        </p>
                                        <div
                                            v-if="choosedItem.id == slide.id"
                                            style="
                                                display: flex;
                                                justify-content: center;
                                            "
                                        >
                                            <p
                                                class="saved"
                                                style="
                                                    border-radius: 20px;
                                                    display: block;
                                                    padding: 2px 15px;
                                                    color: #000;
                                                    font-size: 14px;
                                                "
                                            >
                                                <span>{{
                                                    $t("You save")
                                                }}</span>
                                                <span
                                                    style="
                                                        padding: 0 5px;
                                                        font-weight: bold;
                                                    "
                                                >
                                                    {{
                                                        handleMoney(
                                                            slide.savings
                                                        ) | currency("")
                                                    }}
                                                </span>
                                                <span>
                                                    {{
                                                        shipment.sendFrom
                                                            .country !=
                                                        "United States"
                                                            ? $t(slide.currency)
                                                            : "$"
                                                    }}
                                                </span>
                                            </p>
                                        </div>
                                        <template
                                            v-if="
                                                shipment.sendFrom.country ==
                                                'United States'
                                            "
                                        >
                                            <button
                                                class="curr"
                                                @click.stop="
                                                    toggleCurrency(slide.id)
                                                "
                                            >
                                                {{
                                                    $t(
                                                        useSAR.includes(
                                                            slide.id
                                                        )
                                                            ? "Show in USD"
                                                            : "Show in SAR"
                                                    )
                                                }}
                                            </button>
                                        </template>
                                    </div>

                                    <div
                                        v-if="choosedItem.id == slide.id"
                                        style="margin: 10px auto; width: 75%"
                                    >
                                        <p
                                            class="saved"
                                            style="
                                                border-radius: 20px;
                                                padding: 5px 10px;
                                                background: #000;
                                                color: white;
                                                font-size: 14px;
                                            "
                                        >
                                            <span>{{
                                                $t(
                                                    "Estimated price until the shipment get reweighed through"
                                                )
                                            }}</span>

                                            <span style="padding: 0 5px">{{
                                                slide.provider
                                            }}</span>
                                        </p>
                                    </div>

                                    <div class="l-sec" style="margin-top: 15px">
                                        <div>
                                            <img
                                                v-if="slide.provider == 'DHL'"
                                                style="width: 110px"
                                                src="@/assets/images/DHL-black.png"
                                            />
                                            <img
                                                v-if="slide.provider == 'FedEx'"
                                                style="width: 110px"
                                                src="@/assets/images/FedEx-black.png"
                                            />
                                            <img
                                                v-if="slide.provider == 'UPS'"
                                                style="width: 110px"
                                                src="@/assets/images/UPS-black.png"
                                            />
                                            <img
                                                v-if="slide.provider == 'Zajil'"
                                                style="width: 60px"
                                                src="@/assets/images/Zajil.svg"
                                            />
                                            <img
                                                v-if="slide.provider == 'SAMSA'"
                                                style="width: 110px"
                                                src="@/assets/images/SAMSA.svg"
                                            />
                                            <img
                                                v-if="
                                                    slide.provider == 'ARAMEX'
                                                "
                                                style="width: 110px"
                                                src="@/assets/images/Aramex.svg"
                                            />
                                            <p>{{ $t(slide.serviceType) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </slide>
                </template>
                <template v-for="(slide, i) in rates">
                    <slide v-if="slide.id != lowestService" :key="'s-' + i">
                        <div
                            :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                            class="slider"
                            @click="selectService(slide)"
                        >
                            <div class="slide_parent">
                                <div
                                    :class="[
                                        'slide_child',
                                        { active: choosedItem.id == slide.id },
                                    ]"
                                >
                                    <div>
                                        <div>
                                            <p
                                                :class="[
                                                    'best_offer',
                                                    {
                                                        active:
                                                            choosedItem.id ==
                                                            slide.id,
                                                    },
                                                ]"
                                                v-if="lowestService == slide.id"
                                            >
                                                {{ $t("Best offer") }}
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <p
                                            class="price"
                                            v-if="!useSAR.includes(slide.id)"
                                        >
                                            <span
                                                class="f-45"
                                                v-if="
                                                    shipment.sendFrom.country ==
                                                    'United States'
                                                "
                                                >$</span
                                            >
                                            <span
                                                v-if="!showOnlyPrice"
                                                class="num"
                                            >
                                                <number
                                                    ref="number1"
                                                    :from="
                                                        handleMoney(
                                                            slide.price +
                                                                slide.savings
                                                        )
                                                    "
                                                    :to="
                                                        handleMoney(slide.price)
                                                    "
                                                    :format="theFormat"
                                                    :duration="2"
                                                    :delay="3"
                                                    easing="Power1.easeOut"
                                                />
                                            </span>
                                            <span
                                                v-if="showOnlyPrice"
                                                class="num"
                                                >{{
                                                    (slide.price / 3.75)
                                                        | currency("")
                                                }}</span
                                            >
                                            <span
                                                class="f-10"
                                                v-if="
                                                    shipment.sendFrom.country !=
                                                    'United States'
                                                "
                                                >{{ $t("SAR") }}</span
                                            >
                                        </p>
                                        <p
                                            class="price"
                                            v-if="
                                                shipment.sendFrom.country ==
                                                    'United States' &&
                                                useSAR.includes(slide.id)
                                            "
                                        >
                                            <span class="f-45">{{
                                                slide.price | currency("")
                                            }}</span>
                                            <span>{{ $t("SAR") }}</span>
                                        </p>
                                        <div
                                            v-if="choosedItem.id == slide.id"
                                            style="
                                                display: flex;
                                                justify-content: center;
                                            "
                                        >
                                            <p
                                                class="saved"
                                                style="
                                                    border-radius: 20px;
                                                    display: block;
                                                    padding: 2px 15px;
                                                    color: #000;
                                                    font-size: 14px;
                                                "
                                            >
                                                <span>{{
                                                    $t("You save")
                                                }}</span>
                                                <span
                                                    style="
                                                        padding: 0 5px;
                                                        font-weight: bold;
                                                    "
                                                >
                                                    {{
                                                        handleMoney(
                                                            slide.savings
                                                        ) | currency("")
                                                    }}
                                                </span>
                                                <span>
                                                    {{
                                                        shipment.sendFrom
                                                            .country !=
                                                        "United States"
                                                            ? $t(slide.currency)
                                                            : "$"
                                                    }}
                                                </span>
                                            </p>
                                        </div>
                                        <template
                                            v-if="
                                                shipment.sendFrom.country ==
                                                'United States'
                                            "
                                        >
                                            <button
                                                class="curr"
                                                @click.stop="
                                                    toggleCurrency(slide.id)
                                                "
                                            >
                                                {{
                                                    $t(
                                                        useSAR.includes(
                                                            slide.id
                                                        )
                                                            ? "Show in USD"
                                                            : "Show in SAR"
                                                    )
                                                }}
                                            </button>
                                        </template>
                                    </div>

                                    <div
                                        v-if="choosedItem.id == slide.id"
                                        style="margin: 10px auto; width: 75%"
                                    >
                                        <p
                                            class="saved"
                                            style="
                                                border-radius: 20px;
                                                padding: 5px 10px;
                                                background: #000;
                                                color: white;
                                                font-size: 14px;
                                            "
                                        >
                                            <span>{{
                                                $t(
                                                    "Estimated price until the shipment get reweighed through"
                                                )
                                            }}</span>
                                            <span style="padding: 0 5px">{{
                                                slide.provider
                                            }}</span>
                                        </p>
                                    </div>

                                    <div class="l-sec" style="margin-top: 15px">
                                        <div>
                                            <img
                                                v-if="slide.provider == 'DHL'"
                                                style="width: 110px"
                                                src="@/assets/images/DHL-black.png"
                                            />
                                            <img
                                                v-if="slide.provider == 'FedEx'"
                                                style="width: 110px"
                                                src="@/assets/images/FedEx-black.png"
                                            />
                                            <img
                                                v-if="slide.provider == 'UPS'"
                                                style="width: 110px"
                                                src="@/assets/images/UPS-black.png"
                                            />
                                            <img
                                                v-if="slide.provider == 'Zajil'"
                                                style="width: 90px"
                                                src="@/assets/images/Zajil.svg"
                                            />
                                            <img
                                                v-if="slide.provider == 'SAMSA'"
                                                style="width: 90px"
                                                src="@/assets/images/SAMSA.svg"
                                            />
                                            <img
                                                v-if="
                                                    slide.provider == 'ARAMEX'
                                                "
                                                style="width: 150px"
                                                src="@/assets/images/Aramex.svg"
                                            />
                                            <p>{{ $t(slide.serviceType) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </slide>
                </template>
            </carousel>
        </div>

        <div class="columns rates" v-if="choosedItem">
            <div class="rate-items">
                <div
                    class="dhl-danger"
                    v-if="showDHL_MSG && choosedItem.provider == 'DHL'"
                >
                    <p>
                        {{ $t("Do not send bags with DHL") }}
                    </p>
                    <i class="mdi mdi-close" @click="showDHL_MSG = false"></i>
                </div>
                <div class="rate-item">
                    <div class="r-sec">
                        <div class="sec_3">
                            <div style="display: flex; align-items: flex-end">
                                <p class="title">
                                    {{ $t("Weight") }}
                                </p>
                                <p class="date">
                                    <span class="day">
                                        {{
                                            shipment.total_weight
                                                | number("0,0.0")
                                        }}
                                        {{ $t("kg") }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="l-sec">
                        <div class="sec_3">
                            <div
                                class="del-date"
                                style="display: flex; align-items: center"
                            >
                                <p class="title">
                                    {{ $t("Estimated delivery date") }}
                                </p>
                                <p class="date">
                                    <span class="day">
                                        {{
                                            choosedItem.delivery
                                                | moment("dddd DD")
                                        }}
                                    </span>
                                    <span class="year">{{
                                        choosedItem.delivery | moment("MMM Y")
                                    }}</span>
                                </p>
                            </div>
                            <div class="deadline">
                                <p>{{ $t("This deadline is set by") }}</p>
                                <img
                                    class="ser-logo"
                                    v-if="choosedItem.provider == 'DHL'"
                                    style="width: 50px; border-radius: 50%"
                                    src="@/assets/images/dhl-c.jpg"
                                />
                                <img
                                    class="ser-logo"
                                    v-if="choosedItem.provider == 'FedEx'"
                                    style="width: 50px; border-radius: 50%"
                                    src="@/assets/images/fedex-c.png"
                                />
                                <img
                                    class="ser-logo"
                                    v-if="choosedItem.provider == 'UPS'"
                                    style="width: 50px; border-radius: 50%"
                                    src="@/assets/images/ups-c.png"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="info">
            <div class="info-title">
                <h2 style="margin: 0 5px">
                    {{ $t("Things to know if you ship with") }}
                </h2>
                <img
                    class="ser-logo"
                    v-if="choosedItem.provider == 'DHL'"
                    style="width: 50px; border-radius: 50%"
                    src="@/assets/images/dhl-c.jpg"
                />
                <img
                    class="ser-logo"
                    v-if="choosedItem.provider == 'FedEx'"
                    style="width: 50px; border-radius: 50%"
                    src="@/assets/images/fedex-c.png"
                />
                <img
                    class="ser-logo"
                    v-if="choosedItem.provider == 'UPS'"
                    style="width: 50px; border-radius: 50%"
                    src="@/assets/images/ups-c.png"
                />
            </div>

            <div class="top-lists">
                <div class="info-list">
                    <h4 style="display: flex; align-items: center">
                        <img
                            style="width: 35px; height: 35px"
                            src="@/assets/images/not-allowed.svg"
                        />
                        <span style="margin: 0 10px">
                            {{ $t("Prohibited") }}
                        </span>
                    </h4>
                    <ul>
                        <li
                            v-for="(item, i) in services[choosedItem.provider]
                                .forbidden"
                            :key="i"
                        >
                            <img
                                :src="require(`@/assets/images/${item.img}`)"
                                alt=""
                            />
                            <p>{{ $t(item.text) }}</p>
                        </li>
                    </ul>
                </div>
                <div class="info-list">
                    <h4 style="display: flex; align-items: center">
                        <img
                            style="width: 35px; height: 35px"
                            src="@/assets/images/allowed.svg"
                        />
                        <span style="margin: 0 5px">
                            {{ $t("Allowed") }}
                        </span>
                    </h4>
                    <ul>
                        <li
                            v-for="(item, i) in services[choosedItem.provider]
                                .allowed"
                            :key="i"
                        >
                            <img
                                :src="require(`@/assets/images/${item.img}`)"
                                alt=""
                            />
                            <p>{{ $t(item.text) }}</p>
                        </li>
                    </ul>
                </div>
            </div>

            <hr />

            <div class="bottom-lists">
                <div class="info-list">
                    <h4 style="display: flex; align-items: center">
                        <img
                            style="width: 35px; height: 35px"
                            src="@/assets/images/parcels.svg"
                        />
                        <span style="margin: 0 10px">
                            {{ $t("Type of Parcels") }}
                        </span>
                    </h4>
                    <ul>
                        <li
                            v-for="(item, i) in parcels[choosedItem.provider]"
                            :key="i"
                        >
                            <img
                                :src="require(`@/assets/images/${item.img}`)"
                                alt=""
                            />
                            <p>{{ $t(item.text) }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="note">
            <div class="note-body">
                <h4 style="display: flex; align-items: center">
                    <img
                        style="width: 35px; height: 35px"
                        src="@/assets/images/bell.png"
                    />
                    <span>
                        {{ $t("Note") }}
                    </span>
                </h4>
                <div>
                    <p>
                        {{
                            $t(
                                "In case of not following the instructions may effect on the shipping process, and some additional charges and fees may apply, or your shipment will returned to shipper with charging shipping fees."
                            )
                        }}
                    </p>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            perPage: [[1000, 3]],
            active: 0,
            activeService: -1,
            lowestService: null,
            finalService: null,
            choosedItem: null,
            useSAR: [],
            showOnlyPrice: false,
            activeOne: 0,
            showDHL_MSG: false,
            // slides: [],
            // services: {
            //     UPS: {
            //         allowed: [
            //             {
            //                 img: "clothes.svg",
            //                 text: "Ship clothes and furnitur",
            //             },
            //             {
            //                 img: "cherries.svg",
            //                 text: "Ship food and dried fruit such as dates",
            //             },
            //             {
            //                 img: "grain.svg",
            //                 text: "Ship Grains such as coffee",
            //             },
            //             {
            //                 img: "battery.svg",
            //                 text:
            //                     "Ship all Battery types maximum of two batteries",
            //             },
            //             {
            //                 img: "perfume.svg",
            //                 text: "Ship Perfumes maximum of two pieces",
            //             },
            //             {
            //                 img: "oil.svg",
            //                 text:
            //                     "Ship Oil, Body Lotion and Liquid maximum of two pieces",
            //             },
            //         ],
            //         forbidden: [
            //             {
            //                 img: "nail-polish.svg",
            //                 text: "Ship Nail Polish",
            //             },
            //             {
            //                 img: "jewl.svg",
            //                 text: "Ship Cash, jewelries, and Precious stones",
            //             },
            //             {
            //                 img: "tv.svg",
            //                 text:
            //                     "Sending televisions, according to Baredex statistics, most shipments are damaged due to non-compliance with the correct packaging conditions by the sender, so the prohibition has been made, and the sender can send the TV under his own responsibility.",
            //             },
            //         ],
            //     },
            //     SAMSA: {
            //         allowed: [
            //             {
            //                 img: "clothes.svg",
            //                 text: "Ship clothes and furnitur",
            //             },
            //             {
            //                 img: "cherries.svg",
            //                 text: "Ship food and dried fruit such as dates",
            //             },
            //             {
            //                 img: "grain.svg",
            //                 text: "Ship Grains such as coffee",
            //             },
            //             {
            //                 img: "battery.svg",
            //                 text:
            //                     "Ship all Battery types maximum of two batteries",
            //             },
            //             {
            //                 img: "perfume.svg",
            //                 text: "Ship Perfumes maximum of two pieces",
            //             },
            //             {
            //                 img: "oil.svg",
            //                 text:
            //                     "Ship Oil, Body Lotion and Liquid maximum of two pieces",
            //             },
            //         ],
            //         forbidden: [
            //             {
            //                 img: "nail-polish.svg",
            //                 text: "Ship Nail Polish",
            //             },
            //             {
            //                 img: "jewl.svg",
            //                 text: "Ship Cash, jewelries, and Precious stones",
            //             },
            //             {
            //                 img: "tv.svg",
            //                 text:
            //                     "Sending televisions, according to Baredex statistics, most shipments are damaged due to non-compliance with the correct packaging conditions by the sender, so the prohibition has been made, and the sender can send the TV under his own responsibility.",
            //             },
            //         ],
            //     },
            //     Zajil: {
            //         allowed: [
            //             {
            //                 img: "clothes.svg",
            //                 text: "Ship clothes and furnitur",
            //             },
            //             {
            //                 img: "cherries.svg",
            //                 text: "Ship food and dried fruit such as dates",
            //             },
            //             {
            //                 img: "grain.svg",
            //                 text: "Ship Grains such as coffee",
            //             },
            //             {
            //                 img: "battery.svg",
            //                 text:
            //                     "Ship all Battery types maximum of two batteries",
            //             },
            //             {
            //                 img: "perfume.svg",
            //                 text: "Ship Perfumes maximum of two pieces",
            //             },
            //             {
            //                 img: "oil.svg",
            //                 text:
            //                     "Ship Oil, Body Lotion and Liquid maximum of two pieces",
            //             },
            //         ],
            //         forbidden: [
            //             {
            //                 img: "nail-polish.svg",
            //                 text: "Ship Nail Polish",
            //             },
            //             {
            //                 img: "jewl.svg",
            //                 text: "Ship Cash, jewelries, and Precious stones",
            //             },
            //             {
            //                 img: "tv.svg",
            //                 text:
            //                     "Sending televisions, according to Baredex statistics, most shipments are damaged due to non-compliance with the correct packaging conditions by the sender, so the prohibition has been made, and the sender can send the TV under his own responsibility.",
            //             },
            //         ],
            //     },
            //     FedEx: {
            //         allowed: [
            //             {
            //                 img: "clothes.svg",
            //                 text: "Ship clothes and furnitur",
            //             },
            //             {
            //                 img: "cherries.svg",
            //                 text: "Ship food and dried fruit such as dates",
            //             },
            //             {
            //                 img: "grain.svg",
            //                 text: "Ship Grains such as coffee",
            //             },

            //             {
            //                 img: "battery.svg",
            //                 text: "Ship all Battery types",
            //             },
            //             {
            //                 img: "perfume.svg",
            //                 text: "Ship perfumes and compressed items",
            //             },
            //             {
            //                 img: "oil.svg",
            //                 text: "Ship Oil, Body Lotion and Liquid",
            //             },
            //         ],
            //         forbidden: [
            //             {
            //                 img: "nail-polish.svg",
            //                 text: "Ship Nail Polish",
            //             },
            //             {
            //                 img: "jewl.svg",
            //                 text: "Ship Cash, jewelries, and Precious stones",
            //             },
            //             {
            //                 img: "tv.svg",
            //                 text:
            //                     "Sending televisions, according to Baredex statistics, most shipments are damaged due to non-compliance with the correct packaging conditions by the sender, so the prohibition has been made, and the sender can send the TV under his own responsibility.",
            //             },
            //         ],
            //     },
            //     DHL: {
            //         allowed: [
            //             {
            //                 img: "clothes.svg",
            //                 text: "Ship clothes and furnitur",
            //             },
            //             {
            //                 img: "cherries.svg",
            //                 text: "Ship food and dried fruit such as dates",
            //             },
            //             {
            //                 img: "grain.svg",
            //                 text: "Ship Grains such as coffee",
            //             },
            //         ],
            //         forbidden: [
            //             {
            //                 img: "oil.svg",
            //                 text: "Ship Oil, Body Lotion and Liquid",
            //             },
            //             {
            //                 img: "perfume.svg",
            //                 text: "Ship perfumes and compressed items",
            //             },
            //             {
            //                 img: "battery.svg",
            //                 text: "Ship all Battery types",
            //             },
            //             {
            //                 img: "jewl.svg",
            //                 text: "Ship Cash, jewelries, and Precious stones",
            //             },
            //             {
            //                 img: "tv.svg",
            //                 text:
            //                     "Sending televisions, according to Baredex statistics, most shipments are damaged due to non-compliance with the correct packaging conditions by the sender, so the prohibition has been made, and the sender can send the TV under his own responsibility.",
            //             },
            //         ],
            //     },
            // },
            // parcels: {
            //     UPS: [
            //         {
            //             img: "box.svg",
            //             text:
            //                 "Allowed to ship through shipping boxes, and pallets",
            //         },
            //         {
            //             img: "env.svg",
            //             text: "Allowed to ship through envelopes, and flyers",
            //         },
            //         {
            //             img: "bag.svg",
            //             text: "Allowed to ship through bags",
            //         },
            //     ],
            //     FedEx: [
            //         {
            //             img: "box.svg",
            //             text:
            //                 "Allowed to ship through shipping boxes, and pallets",
            //         },
            //         {
            //             img: "env.svg",
            //             text: "Allowed to ship through envelopes, and flyers",
            //         },
            //         {
            //             img: "bag.svg",
            //             text: "Allowed to ship through bags",
            //         },
            //     ],
            //     DHL: [
            //         {
            //             img: "box.svg",
            //             text:
            //                 "Allowed to ship through shipping boxes, and pallets",
            //         },
            //         {
            //             img: "env.svg",
            //             text: "Allowed to ship through envelopes, and flyers",
            //         },
            //         {
            //             img: "bag.svg",
            //             text: "Not allowed to ship through bags",
            //         },
            //     ],
            //     SAMSA: [
            //         {
            //             img: "box.svg",
            //             text:
            //                 "Allowed to ship through shipping boxes, and pallets",
            //         },
            //         {
            //             img: "env.svg",
            //             text: "Allowed to ship through envelopes, and flyers",
            //         },
            //         {
            //             img: "bag.svg",
            //             text: "Not allowed to ship through bags",
            //         },
            //     ],
            //     Zajil: [
            //         {
            //             img: "box.svg",
            //             text:
            //                 "Allowed to ship through shipping boxes, and pallets",
            //         },
            //         {
            //             img: "env.svg",
            //             text: "Allowed to ship through envelopes, and flyers",
            //         },
            //         {
            //             img: "bag.svg",
            //             text: "Not allowed to ship through bags",
            //         },
            //     ],
            // },
        };
    },
    watch: {
        getService: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.$emit("finish", true);
                    return true;
                } else {
                    this.$emit("finish", false);
                    return false;
                }
            },
        },
        rates: {
            immediate: true,
            handler(val) {
                if (val && val.length) {
                    this.getLowestPrice();

                    setTimeout(() => {
                        this.perPage = [
                            [300, 1],
                            [1000, 3],
                        ];
                    }, 100);
                }
            },
        },
    },
    methods: {
        toggleCurrency(id) {
            this.showOnlyPrice = true;
            if (!this.useSAR.includes(id)) return this.useSAR.push(id);
            this.useSAR = this.useSAR.filter((i) => i != id);
        },
        handleMoney(money) {
            if (this.shipment.sendFrom.country != "United States") return money;
            return money / 3.75;
        },
        theFormat(number) {
            return this.$options.filters.currency(number.toFixed(2), "");
        },
        hideForm() {
            this.$el.classList.add("hide-form-container");
        },
        getLowestPrice() {
            let lowestPrice = this.rates[0].price;
            this.choosedItem = this.rates[0];
            if (this.rates && this.rates.length) {
                this.activeService = this.rates[0].id;
                this.$store.dispatch("service", this.rates[0]);
            }

            this.rates.map((r, i) => {
                if (r.price < lowestPrice) {
                    lowestPrice = r.price;
                    this.activeService = r.id;
                    this.choosedItem = r;
                    this.$store.dispatch("service", r);
                    if (this.choosedItem.provider == "DHL") {
                        this.showDHL_MSG = true;
                    }
                }
            });

            this.lowestService = this.activeService;
            this.finalService = this.activeService;
        },
        selectService(slide) {
            if (this.finalService == slide.id) return;
            if (this.activeService != -1) {
                this.activeService = slide.id;
                this.finalService = slide.id;
            }

            this.choosedItem = slide;

            if (this.choosedItem.provider == "DHL") {
                this.showDHL_MSG = true;
            }
            this.$store.dispatch("service", slide);
        },
        allowNext() {
            return true;
        },
    },
    computed: {
        rates() {
            return this.$store.getters.getRates;
        },
        getService() {
            return this.$store.getters.getService;
        },
        shipment() {
            return this.$store.getters.shipment;
        },
    },
};
</script>

<style lang="scss" scoped>
.dhl-danger {
    background: rgba(255, 99, 71, 0.713);
    color: black;
    border-radius: 7px;
    padding: 10px;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.more-rates {
    position: absolute;
    top: 488px;
    right: -5px;
    -webkit-transform: rotate(90deg);
    transform: rotate(-90deg);
    font-size: 18px;
    color: #000;
}

.note {
    margin: 20px 100px;

    .note-body {
        h4 {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin-bottom: 15px;
        }

        div {
            p {
                font-size: 16px;
                color: #333;
            }
        }
    }
}

.info {
    background: #f7f7f7;
    padding: 25px;
    margin: 0 70px;
    border-radius: 10px;

    .info-title {
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        h2 {
            font-size: 24px;
            color: #333;
            font-weight: bold;
            margin: 0 10px;
        }
    }

    hr {
        border-top: 4px solid #fff;
        width: 85%;
    }

    .top-lists {
        padding: 0 40px;
        margin-bottom: 30px;
        display: flex;

        @media screen and (max-width: 1000px) {
            padding: 0 10px !important;
        }

        .info-list {
            width: 50%;
            background: none;

            h4 {
                font-size: 24px;
                font-weight: bold;
                color: #333;
                margin-bottom: 15px;
            }

            li {
                display: flex;
                align-items: flex-start;
                padding: 5px 0;
                font-size: 16px;
                font-weight: 100 !important;

                img {
                    width: 26px;
                    height: 26px;
                    margin: 0 3px;
                }

                p {
                    margin: 0 10px;
                }
            }
        }
    }

    .bottom-lists {
        padding: 0 40px;
        background: none;

        h4 {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin-bottom: 15px;
        }

        li {
            font-size: 16px;
            font-weight: 100 !important;
            display: flex;
            align-items: center;
            padding: 5px 0;

            img {
                width: 26px;
                height: 26px;
                margin: 0 3px;
            }

            p {
                margin: 0 10px;
            }
        }
    }

    @media screen and (max-width: 1000px) {
        margin: 0 25px;
    }
}

.curr {
    background: transparent;
    padding: 0;
    border-radius: 50px;
    box-shadow: none;
    font-size: 12px;
    border: 1px solid #656565;
    color: #313131;
    width: 40%;
    padding: 4px 7px;
    cursor: pointer;

    &:focus {
        border: 1px solid #656565 !important;
    }
}

.best_offer {
    font-size: 16px !important;
    position: absolute;
    width: 171px;
    border-radius: 0;
    transform: rotate(-45deg);
    top: 26px;
    left: -51px;
    background: tomato;
    color: white;
}

.form-container {
    min-height: 540px;
}

.rates {
    margin: 10px 0;
}

.rate-items {
    width: 100%;
    padding: 0 20px;
    margin: 0 50px;
    cursor: pointer;

    .rate-item {
        display: flex;

        &.active {
            transition: 0.5s ease-in;
            background: #6c7cbc95;
            color: black !important;
        }

        .l-sec {
            width: 75% !important;
            text-align: center;
            border-left: 1px solid #fff;
            background: #f2f2f2;
            border-radius: 10px;
            margin-bottom: 20px;
            margin: 0 5px;
            padding: 15px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
        }

        .r-sec {
            background: #f2f2f2;
            border-radius: 10px;
            margin-bottom: 20px;
            margin: 0 5px;
            padding: 15px 0;
            width: 25% !important;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
        }
    }

    @media screen and (max-width: 1000px) {
        margin: 0;

        .rate-item {
            flex-wrap: wrap;

            .l-sec {
                width: 100% !important;
            }

            .r-sec {
                margin-bottom: 5px;
                width: auto !important;
            }
        }
    }
}

.price {
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    height: 55px;

    .num {
        font-size: 45px;
        padding: 0 5px;
    }
}

#form-title-top {
    display: inline-block;
    font-size: 25px;
    padding: 0 15px;
}

.slider {
    display: flex;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    margin-bottom: 30px;
    padding: 10px;

    .slide_parent {
        display: flex;
        justify-content: center;
        align-items: flex-start;

        .slide_child {
            position: relative;
            overflow: hidden;
            color: black;
            background: #f2f2f2;
            border-radius: 10px;
            width: 330px;
            transition: 0.5s ease-in;
            padding-bottom: 40px;
            padding: 10px 0 25px;

            &.active {
                background-color: #8989bb;
                background-image: linear-gradient(
                    315deg,
                    #8989bb 0%,
                    #a5a4cb 74%
                );

                .sec_1,
                .sec_2,
                .sec_3,
                .sec_4,
                .right {
                    border-color: white !important;
                }

                .left {
                    display: none;
                }

                .right {
                    width: 100% !important;
                    border: none !important;
                }
            }

            .sec_1 {
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                border-bottom: 1px solid #aaa;
                margin-top: 10px;

                p {
                    font-size: 14px;
                    margin-top: 5px;
                    margin-bottom: 5px;
                }
            }

            .sec_2 {
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                padding: 10px 30px;

                .title {
                    text-align: left;
                    font-size: 16px;
                    margin: 0 0 10px;
                    font-weight: 400;
                    color: #000 !important;
                }

                .weight {
                    width: 100%;
                    font-size: 35px;
                    font-weight: bold;
                }
            }

            .sec_4 {
                display: flex;
                padding: 8px;

                .note {
                    writing-mode: vertical-lr;
                    text-orientation: mixed;
                    transform: rotate(-180deg);
                    text-align: center;
                    font-size: 30px;
                    padding: 0 5px;
                    font-weight: bold;
                    letter-spacing: 2px;
                }

                .desc {
                    text-align: left;
                }
            }

            .sec_5 {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .left {
                    width: 50%;
                    padding: 10px 0;
                    cursor: pointer;
                }

                .right {
                    width: 50%;
                    border-left: 1px solid #aaa;
                    padding: 10px 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;

                    p {
                        padding: 5px;
                    }
                }
            }
        }
    }
}

.sec_3 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 10px 0;

    .title {
        font-weight: bold !important;
        text-align: left;
        font-size: 20px;
        margin: 0 0 10px;
        font-weight: 400;
        color: #000;
    }

    .date {
        font-weight: bold;
        font-size: 20px;
        color: #000;
        margin: 0 20px 6px;

        // .day {
        // }

        // .year {
        //     padding: 0 3px;
        // }
    }

    .deadline {
        display: flex;
        align-items: center;

        p {
            font-weight: bold;
            color: #333;
            font-size: 16px;
            margin: 0 10px;
        }
    }
}

.panel:not(:last-child) {
    margin-bottom: 0 !important;
}

// .glide__track {
//     overflow: initial !important;
// }
.glide__slide {
    text-align: center;
    // width: 315px !important;
}

[data-glide-el="controls"] {
    position: relative;

    #control-left,
    #control-right {
        position: absolute;
        z-index: -1;
        transition: 0.25s linear;
        cursor: pointer;
        color: #000;
        top: 78px;
        font-size: 25px;
    }

    #control-left:hover,
    #control-right:hover {
        color: #6174eb;
    }

    #control-left.visible,
    #control-right.visible {
        z-index: 5 !important;
    }

    #control-left {
        left: -5px;
    }

    #control-right {
        right: -5px;
    }
}

.f-10 {
    font-size: 10px;
}

.f-45 {
    font-size: 45px;
}

@media screen and (max-width: 750px) {
    .r-sec .sec_3 .title {
        font-size: 18px !important;
    }

    .l-sec .sec_3 {
        flex-wrap: wrap;
        justify-content: space-between;

        .title {
            font-size: 18px !important;
        }

        .date {
            font-size: 18px !important;
        }
    }

    .del-date {
        flex-wrap: wrap !important;
    }

    .deadline {
        width: 100%;
        justify-content: flex-end;
    }

    .ser-logo {
        width: 35px !important;
    }

    .rate-items {
        padding: 0 5px !important;
    }

    .info {
        margin: 0 10px !important;
        padding: 10px !important;

        .info-title h2 {
            font-size: 18px;
        }

        .top-lists {
            flex-wrap: wrap;

            li {
                font-size: 14px !important;
            }

            h4 {
                font-size: 22px !important;

                img {
                    width: 25px !important;
                    height: 25px !important;
                }
            }

            .info-list {
                width: 100% !important;
                margin-bottom: 20px;
            }
        }

        .bottom-lists {
            padding: 0 10px !important;

            li {
                font-size: 14px !important;
            }

            h4 {
                font-size: 22px !important;

                img {
                    width: 25px !important;
                    height: 25px !important;
                }
            }
        }
    }

    .note {
        margin: 20px;

        h4 {
            font-size: 22px !important;

            img {
                width: 25px !important;
                height: 25px !important;
            }
        }

        p {
            font-size: 14px !important;
        }
    }
}
</style>
